(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    function fillItemEnquiry() {
    const params = new URLSearchParams(window.location.search);
    const item = params.get('item');
    if (!item) return;
    document.querySelectorAll('.contact-form[data-asd-item]').forEach(container => {
      const field = container.querySelector('textarea[name="contact[body]"]');
      if (!field || field.value.trim()) return;
      const reference = params.get('reference');
      const lines = [container.dataset.asdItem + ': ' + item.slice(0, 300)];
      if (reference) lines.push(container.dataset.asdReference + ': ' + reference.slice(0, 100));
      lines.push(container.dataset.asdDestination + ': ', '', container.dataset.asdQuestion + ': ');
      field.value = lines.join('\n');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fillItemEnquiry, { once: true });
  else fillItemEnquiry();
  } catch(e) { console.error(e); }
})();

})();
